

<template>
    <div class="splashscreen-component component-view fullscreen d-flex pb-10 align-items-center text-center justify-content-center">
        <h2>
            <i class="fal fa-circle-notch fa-spin"></i> <br>
            <span>Loading...</span>
        </h2>
    </div>
</template>

<script>

import { mapState } from 'vuex';
import { EventBus } from '@/common/eventbus.js';

export default {
	props: [],
    data: function () {
        return {
        }
    },
    computed: {
        ...mapState(['settings']),
	},

    updated: function () {
        //console.log( this );
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
	.splashscreen-component {
        background: #fff;
        color: #ddd;
        span {
            font-size: 1.5rem;
        }
    }
</style>
